import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const calculateRentPriceAPI = async ({
    startDate,
    endDate,
    vehicleId,
    expectedKm = 0,
    options = [],
    products = {},
    subsidiary = null
}) => {
    const requestSubsidiary = resolveWhiteLabelSubsidiaryId(subsidiary);

    const query = new URLSearchParams({
        start_date: startDate,
        end_date: endDate,
        expected_kilometers: expectedKm
    })
    options.forEach((optionId) => {
        if (optionId !== null && optionId !== undefined) {
            query.append('options[]', String(optionId))
        }
    })

    const serializedProducts = Object.entries(products || {}).map(([productId, productPayload]) => {
        const parsedProductId = Number(productId)
        const parsedQuantity = Number(
            typeof productPayload === "object" && productPayload !== null
                ? productPayload.quantity
                : productPayload
        )
        const parsedDays = Number(
            typeof productPayload === "object" && productPayload !== null
                ? productPayload.days
                : NaN
        )
        if (!Number.isFinite(parsedProductId) || parsedProductId <= 0) return null
        if (!Number.isFinite(parsedQuantity) || parsedQuantity <= 0) return null
        const normalizedQty = Math.floor(parsedQuantity)
        if (Number.isFinite(parsedDays) && parsedDays > 0) {
            return `${parsedProductId}:${normalizedQty}:${Math.floor(parsedDays)}`
        }
        return `${parsedProductId}:${normalizedQty}`
    }).filter(Boolean).join(",")

    if (serializedProducts) {
        query.append("products", serializedProducts)
    }

    if (requestSubsidiary) {
        query.append('required_subsidiary', requestSubsidiary)
    }

    const URL = `${BASE_URL}/public/p2p/vehicle/detail/${vehicleId}/pricing?${query.toString()}`
    const METHOD = "GET"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    console.log(URL)

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS
    })

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`)
    }

    return await response.json()
}

export {calculateRentPriceAPI}
